import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxPermissionsModule } from 'ngx-permissions';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ChipsModule } from 'primeng/chips';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { EditorModule } from 'primeng/editor';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MultiSelectModule } from 'primeng/multiselect';
import { PanelModule } from 'primeng/panel';
import { RatingModule } from 'primeng/rating';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { CouponFormModule } from 'src/app/components/coupon-form/coupon-form.module';
import { EmailTemplateFormModule } from 'src/app/components/email-template-form/email-template-form.module';
import { GridstackModule } from 'src/app/components/gridstack/gridstack.module';
import { ShopCouponFormModule } from 'src/app/components/shop-coupon-form/shop-coupon-form.module';
import { AppTableModule } from 'src/app/components/table/app-table.module';
import { Buy2WinComponent } from './buy-2-win/buy-2-win.component';
import { CampaignDetailsComponent } from './buy-2-win/campaign-details/campaign-details.component';
import { CampaignGenerateComponent } from './campaigns/campaign-generate/campaign-generate.component';
import { CampaignHistoryComponent } from './campaigns/campaign-history/campaign-history.component';
import { CampaignRulesComponent } from './campaigns/campaign-rules/campaign-rules.component';
import { CampaignsComponent } from './campaigns/campaigns.component';
import { CouponChangeScheduleModalComponent } from './coupons/coupon-detail/coupon-change-schedule-modal/coupon-change-schedule-modal.component';
import { CouponDetailComponent } from './coupons/coupon-detail/coupon-detail.component';
import { CouponProductVariantsComponent } from './coupons/coupon-detail/coupon-product-variants/coupon-product-variants.component';
import { CouponsComponent } from './coupons/coupons.component';
import { EmailRestrictionFormComponent } from './coupons/email-restriction-form/email-restriction-form.component';
import { EmailTemplatesComponent } from './email-templates/email-templates.component';
import { MarketingRoutingModule } from './marketing-routing.module';
import { MgmComponent } from './mgm/mgm.component';
import { MgmCycleDetailComponent } from './mgm/mgm-cycle-detail/mgm-cycle-detail.component';
import { MgmCycleFormComponent } from './mgm/mgm-cycle-form/mgm-cycle-form.component';
import { ShopCouponDetailComponent } from './shop-coupons/shop-coupon-detail/shop-coupon-detail.component';
import { ShopCouponsComponent } from './shop-coupons/shop-coupons.component';

@NgModule({
  declarations: [
    CouponsComponent,
    CouponDetailComponent,
    EmailRestrictionFormComponent,
    CouponChangeScheduleModalComponent,
    CouponProductVariantsComponent,
    ShopCouponsComponent,
    ShopCouponDetailComponent,
    Buy2WinComponent,
    CampaignDetailsComponent,
    EmailTemplatesComponent,
    CampaignsComponent,

    CampaignRulesComponent,
    CampaignGenerateComponent,
    CampaignHistoryComponent,
    MgmComponent,
    MgmCycleFormComponent,
    MgmCycleDetailComponent
  ],
  providers: [ConfirmationService, DialogService, MessageService],
  imports: [
    CommonModule,
    MarketingRoutingModule,
    CouponFormModule,
    AppTableModule,
    TabViewModule,
    RouterModule,
    GridstackModule,
    ButtonModule,
    RatingModule,
    FormsModule,
    InputNumberModule,
    CheckboxModule,
    DialogModule,
    ToastModule,
    TooltipModule,
    ConfirmDialogModule,
    FileUploadModule,
    ChipsModule,
    ReactiveFormsModule,
    CalendarModule,
    DropdownModule,
    DynamicDialogModule,
    EditorModule,
    InputSwitchModule,
    PanelModule,
    CardModule,
    AutoCompleteModule,
    ConfirmPopupModule,
    FieldsetModule,
    InputTextModule,
    InputTextareaModule,
    InputMaskModule,
    ShopCouponFormModule,
    MultiSelectModule,
    ChipModule,
    SelectButtonModule,
    ProgressSpinnerModule,
    EmailTemplateFormModule,
    NgxPermissionsModule.forChild()
  ]
})
export class MarketingModule {}
